export default "__VITE_ASSET__ls14aPyO__"